import { Position } from 'src/libs/models'

export const TOURISM_TYPE_OPTIONS = [
  { label: Position.TypeText[Position.Type.ScenicSpot], value: Position.Type.ScenicSpot },
  { label: Position.TypeText[Position.Type.Restaurant], value: Position.Type.Restaurant },
  { label: Position.TypeText[Position.Type.Hotel], value: Position.Type.Hotel },
]
